import React, { useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';

import { CharAlert, ErrorText } from './FormAlerts'

const InputForm = ({addTweet, error}) => {
  const [user] = useAuthState(auth)
  const [value, setValue] = useState()
  const [tweetTooLong, setTweetTooLong] = useState(false)

  const handleSubmit = e => {
    e.preventDefault();
    addTweet(value, new Date().toISOString())
    setValue('')
  }
  const handleTweet = tweet => {
    if (tweet.length >= 140) {
      setTweetTooLong(true)
    } else {
      setTweetTooLong(false)
      setValue(tweet)
    }
  }
  
  return (
    <>
      <form className="form" onSubmit={handleSubmit}>
        <textarea 
          className="form__input"
          name="input" 
          type="text"
          value={value}
          required2
          placeholder="What do you have in mind...?"
          onChange={e => handleTweet(e.target.value)}
        />
          <button
            className={tweetTooLong ? "form__button red" : "form__button"}
            name="alert"
            disabled={tweetTooLong}
            type="submit">
            Tweet!
          </button>
        {tweetTooLong && <CharAlert />}
        {error && <ErrorText />}
      </form>
    </>
  )
}

export default InputForm
